













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { AttributeMixin, RenderMenuMixin } from '@/mixins';
import { SearchMixin } from '@acgn/herm/src/mixins';

import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
} from '@acgn/herm/src/ui';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';

const ComicAction = namespace('desk/comic').Action;

const ComicGetter = namespace('desk/comic').Getter;

interface SearchType { // 项目搜索字段
  name?: string; // 漫画项目名称
  page?: number; // 当前页码
}

// 组件申明
@Component({
  components: {
    AcgnSearchWrap,
    AcgnTable,
    AcgnTopButton
  },
  mixins: [AttributeMixin, SearchMixin, RenderMenuMixin]
})
export default class ComicList extends Vue {

  @ComicAction private getComicList: any; // 获取漫画项目列表
  @ComicAction private deleteComic: any; // 上架/下架漫画项目

  @ComicGetter private comicList: any; // 漫画项目列表
  @ComicGetter private loadings: any; // 漫画项目loading

  private searchForm: SearchType = { // 头部筛选项
    name: '',
    page: 1
  };

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  // 列表配置
  private tableConfig: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        type: 'selection',
        width: 48,
        prop: 'id'
      },
      {
        label: '项目名称',
        prop: 'gname'
      },
      {
        label: '图标',
        prop: 'icon',
        render: (h: any, { row }: any) => (this as any).renderPic(row)
      },
      {
        minWidth: 100,
        label: '创建时间',
        prop: 'create_time',
        render(h: any, { row }: any) {
          return h('span', setDateTimeStamp(row.update_time, 'YYYY-MM-DD HH:mm:ss'));
        }
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              icon: `ift-fee`,
              color: '#73c800',
              text: '编辑',
              type: 'edit',
              disabled: false,
              to: {
                name: 'desk-demoEdit',
                params: {
                  id: row.id
                }
              },
            },
            {
              icon: 'ift-chapter',
              color: '#73c800',
              text: '版本管理',
              type: 'detail',
              disabled: false
            }
          ];
          btns.push({
            icon: `${row.state === 1 ? 'ift-delete' : 'ift-cancel'}`,
            color: `${row.state === 1 ? '#ff3c00' : '#73c800'}`,
            text: `${row.state === 1 ? '下架' : '上架'}`,
            type: 'delete',
            disabled: false
          });
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private async created() {
    const cacheForm: any = this.$getFormCache();
    this.searchForm = { ...this.searchForm, ...cacheForm };
    if (this.searchForm.page) { // 如果有缓存页码，先赋值
      this.pageConfig.currentPage = this.searchForm.page;
    }
  }

  private renderPic(row: any) {
    return (
      <img src={(window as any).configs.imageDomain + row.icon} style="width:50px;height:50px;" />
    );
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <div class="acgn-side-box__menu">
        <div class="menu-title">项目状态</div>
        <ul class="menu-status-list">
          <li class="menu-status-item selected">
            <div class="item-left">
              <span class="status-icon"></span>
              <span>进行中</span>
            </div>
            <div class="item-right">
              <span class="status-num">3</span>
            </div>
          </li>
          <li class="menu-status-item">
            <div class="item-left">
              <span class="status-icon"></span>
              <span>已完结</span>
            </div>
            <div class="item-right">
              <span>2</span>
            </div>
          </li>
          <li class="menu-status-item">
            <div class="item-left">
              <span class="status-icon"></span>
              <span>已暂停</span>
            </div>
            <div class="item-right">
              <span>1</span>
            </div>
          </li>
          <li class="menu-status-item">
            <div class="item-left">
              <span class="status-icon"></span>
              <span>已暂停</span>
            </div>
            <div class="item-right">
              <span>1</span>
            </div>
          </li>
          <li class="menu-title">
            <span>项目状态</span>
            <div class="menu-title__right">
              <span class="acgn-icon ift-sort"></span>
              <span class="acgn-icon ift-add"></span>
            </div>
          </li>
          <li class="menu-status-item selected">
            <div class="item-left">
              <span class="acgn-icon ift-stat_1"></span>
              <span>数据统计</span>
            </div>
          </li>
          <li class="menu-status-item">
            <div class="item-left">
              <span class="acgn-icon ift-project_2"></span>
              <span>项目概况</span>
            </div>
          </li>
          <li class="menu-status-item">
            <div class="item-left">
              <span class="acgn-icon ift-staff_1"></span>
              <span>员工数据</span>
            </div>
          </li>
          <li class="menu-status-item">
            <el-input
              class="status-input"
              size="small"
              prefix-icon="acgn-icon ift-search"
              placeholder="搜索"
            />
          </li>
          <li class="menu-status-item small">
            <div class="item-left">
              <span class="breaker">第4话第4话第4话第4话</span>
            </div>
            <div class="item-right">
              <span class="color--success">已过审</span>
            </div>
          </li>
          <li class="menu-status-item small">
            <div class="item-left">
              <span class="breaker">第4话第4话第4话第4话</span>
            </div>
            <div class="item-right">
              <span class="color--danger">审批拒绝</span>
            </div>
          </li>
          <li class="menu-status-item small">
            <div class="item-left">
              <span class="breaker">第4话第4话第4话第4话</span>
            </div>
            <div class="item-right">
              <span class="color--warning">审批中</span>
            </div>
          </li>
          <li class="menu-status-item small">
            <div class="item-left">
              <span class="breaker">第4话第4话第4话第4话</span>
            </div>
            <div class="item-right">
              <span>待提交</span>
            </div>
          </li>
        </ul>
      </ div>
    );
  }

  // 列表操作项
  private onListAction(item: any) {
    switch (item.type) {
      case 'delete':
        this.delete(item.row);
        break;
    }
  }

  // 刷新当前页
  private reloadList() {
    this.initSearh({ page: this.pageConfig.currentPage });
  }

  // 删除
  private async delete(rows: any) {
    try {
      this.$confirm(`确认删除漫画项目?`, '提示').then(async () => {
        await this.deleteComic({
          id: rows.id
        });
        this.$message.success(`删除成功`);
        this.initSearh({ page: this.pageConfig.currentPage });
      }).catch((ex) => { });
    } catch (ex) {
      this.$message.error(this.$language.error);
    }
  }

  // 搜索
  private search() {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    const { tableConfig, pageConfig } = this;
    const options = {
      ...filterEmpty(this.searchForm),
      page,
      size: 30
    };
    await this.getComicList(options);
    const { result, paging } = this.comicList;
    tableConfig.data = result.list;
    pageConfig.currentPage = paging.page;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;

    const { page_size, ...args } = options;
    this.$setFormCache({ ...args });
  }
}
